import { SET_LOGGEDIN, SET_TOKEN, SET_USER_DETAILS, SET_MENU_ITEMS, SET_SELLERCREATION, SET_ACCOUNTTYPE, SET_BUYNOWPRODUCTS, SET_ACCOUNT_DETAILS, SET_REGION, SET_CURRENT_DELIVERY_ADDRESS } from "./constants";
import authStore from "./stores";

const authReducers = (state = authStore, action) => {
    switch (action.type) {
        case SET_LOGGEDIN:
            return { ...state, isLoggedIn: action.payload }
        case SET_TOKEN:
            return { ...state, token: action.payload }
        case SET_USER_DETAILS:
            return { ...state, userDetails: action.payload }
        case SET_MENU_ITEMS:
            return { ...state, menuItems: action.payload }
        case SET_SELLERCREATION:
            return { ...state, sellerCreation: action.payload }
        case SET_ACCOUNTTYPE:
            return { ...state, accountType: action.payload }
        case SET_BUYNOWPRODUCTS:
            return { ...state, buyNow: action.payload }
        case SET_ACCOUNT_DETAILS:
            return { ...state, accountDetails: action.payload }
        case SET_REGION:
            return { ...state, region: action.payload }
        case SET_CURRENT_DELIVERY_ADDRESS:
            return { ...state, currentDeliveryAddress: action.payload }
        default:
            return state
    }
}

export default authReducers